import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { Loader, BaasicInput, DatePicker, BaasicDropdown, AddressAutofill } from 'core/components';
import isShippingStateAvailable from 'core/utils/isShippingStateAvailable';

const EditOrderTemplate = ({
	t,
	editOrderViewStore: {
		loading,
		form,
		modalParams,
		datePickerFormat,
		addressAutofillViewStore,
		countryDropdownStore,
		stateDropdownStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('FULFILLMENTORDER.EDITMODAL.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="spc--bottom--sml">
						<DatePicker field={form.$('shipByDate')} format={datePickerFormat} />
					</div>
					<BaasicInput field={form.$('buyerName')} className="fs-mask" />
					<AddressAutofill viewStore={addressAutofillViewStore} t={t} />
					<BaasicInput field={form.$('shippingAddress2')} className="fs-mask" />
					<BaasicInput field={form.$('shippingCity')} />
					<BaasicInput field={form.$('shippingZipCode')} />
					<BaasicInput field={form.$('buyerPhone')} className="fs-mask" />
					<BaasicDropdown dropdownStore={countryDropdownStore} isClearable={true} className="spc--bottom--sml" />
					<BaasicDropdown
						isDisabled={
							countryDropdownStore.value && !isShippingStateAvailable(countryDropdownStore.value.extra.countryCode)
						}
						dropdownStore={stateDropdownStore}
						isClearable={true}
						className="spc--bottom--sml"
					/>
				</div>
				<div className="ReactModal__footer">
					<button className="btn btn--med btn--primary spc--right--sml spc--bottom--sml" type="submit">
						{t('SAVE')}
					</button>
					<button className="btn btn--med btn--secondary spc--bottom--sml" type="button" onClick={modalParams.close}>
						{t('BACK')}
					</button>
				</div>
			</form>
		</section>
	);
};

export default defaultTemplate(EditOrderTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/EditOrderTemplate.jsx